function isSafeRedirectUrl(url: string): boolean {
  try {
    // Allow relative URLs
    if (url.startsWith("/") && !url.startsWith("//")) {
      const lower = url.toLowerCase();
      if (
        !lower.includes("javascript:") &&
        !lower.includes("data:") &&
        !lower.includes("vbscript:")
      ) {
        return true;
      }
    }

    // Allow HTTPS URLs from Auth0 domain (signup redirect)
    try {
      const parsedUrl = new URL(url);
      const hostname = parsedUrl.hostname.toLowerCase();

      // Only allow HTTPS protocol
      if (parsedUrl.protocol !== "https:") {
        return false;
      }

      // Check if hostname is from Auth0 (supports both configured domain and *.auth0.com pattern)
      const auth0Domain = import.meta.env.VITE_AUTH0_DOMAIN?.toLowerCase();
      const isAuth0Domain =
        hostname === auth0Domain ||
        hostname.endsWith(".auth0.com") ||
        hostname === "auth0.com";

      if (isAuth0Domain) {
        // Additional safety check: ensure no dangerous protocols in the URL
        const lower = url.toLowerCase();
        if (
          !lower.includes("javascript:") &&
          !lower.includes("data:") &&
          !lower.includes("vbscript:")
        ) {
          return true;
        }
      }
    } catch {
      // If URL parsing fails, it's not a valid absolute URL
      return false;
    }

    return false;
  } catch {
    return false;
  }
}

export function getSafeRedirectUrl(url: string | null): string {
  if (url && isSafeRedirectUrl(url)) {
    return url;
  }
  return "/";
}
